export default {
    setUser(userData) {
        sessionStorage.setItem("userData", JSON.stringify(userData));
    },
    getUser() {
        let storageUserData = sessionStorage.getItem("userData");
        if (storageUserData) {
            return JSON.parse(storageUserData);
        } else {
            return null;
        }
    },
    removeUser() {
        sessionStorage.removeItem("userData");
    },
    isLogin() {
        let userData = this.getUser();
        return userData != null;
    },
}


// WEBPACK FOOTER //
// ./src/commons/UserStore.js